import type { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
    form: {
        width: '100%',
    },
    container: {
        [theme.breakpoints.up('md')]: {
            maxWidth: theme.spacing(44.75),
        },
    },
    error: {
        paddingBottom: theme.spacing(0.5),
    },
    sqidError: {
        paddingBottom: theme.spacing(1.5),
    },
}));
